import ScalarCopyBackdrop_vue_vue_type_script_setup_true_lang_default from "./ScalarCopyBackdrop.vue_vue_type_script_setup_true_lang.js";
//#region src/components/ScalarCopy/ScalarCopyBackdrop.vue
var ScalarCopyBackdrop_default = ScalarCopyBackdrop_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarCopyBackdrop_default as default };

//# sourceMappingURL=ScalarCopyBackdrop.vue.js.map